import { useAuth0 } from '@auth0/auth0-react';
import { BlankScreen } from '@strata/react-page-templates';
import { Outlet, useLocation } from 'react-router';

import { SideNav } from 'components/SideNav';
import { LOGIN_REDIRECT_KEY } from 'services/constants';

/**
 * Component to determine if a user is authenticated and
 * if they are allowed to visit the page they navigated to.
 *
 * If they are: they proceed to the page
 * If not: they are redirected to the login page.
 */
export const RequireAuth = () => {
    const { isAuthenticated, loginWithRedirect } = useAuth0();
    const location = useLocation();

    if (!isAuthenticated) {
        sessionStorage.setItem(
            LOGIN_REDIRECT_KEY,
            `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`,
        );
        loginWithRedirect();
        return <BlankScreen />;
    }

    return (
        <SideNav>
            <Outlet />
        </SideNav>
    );
};
